export const translations = {
  en: {
    nav: {
      home: "Home",
      pricing: "Pricing",
      dashboard: "Dashboard",
      admin: "Admin Panel",
      login: "Login",
      register: "Register",
      logout: "Logout",
    },
    hero: {
      title: "Free Dynamic DNS",
      subtitle: "Get your free subdomain on dnslab.biz. Manage A, AAAA, and CNAME records with our powerful dashboard.",
      cta: "Get Started Free",
      learn: "View Pricing",
    },
    features: {
      title: "Why DNSLAB.BIZ?",
      subtitle: "Everything you need for reliable DNS management",
      speed: { title: "Lightning Fast", desc: "DNS propagation in seconds via Cloudflare's global network." },
      security: { title: "Secure by Default", desc: "Protected by Cloudflare's enterprise-grade security infrastructure." },
      free: { title: "Free Forever", desc: "Create up to 2 DNS records completely free. No credit card needed." },
      easy: { title: "Easy Dashboard", desc: "Intuitive dashboard to create and manage all your DNS records." },
      types: { title: "Multiple Record Types", desc: "Full support for A, AAAA, CNAME, and NS record types." },
      api: { title: "Real DNS Records", desc: "Records are created on Cloudflare's infrastructure. Real DNS, not a proxy." },
    },
    pricing: {
      title: "Simple Pricing",
      subtitle: "Start free, upgrade when you need more",
      free: {
        title: "Free",
        price: "$0",
        period: "forever",
        features: ["2 DNS Records", "A, AAAA, CNAME, NS Types", "Cloudflare DNS", "Dashboard Access"],
        cta: "Get Started",
      },
      pro: {
        title: "Pro",
        price: "Contact",
        period: "",
        features: ["Unlimited Records", "A, AAAA, CNAME, NS Types", "Cloudflare DNS", "Priority Support", "Custom TTL"],
        cta: "Contact on Telegram",
        popular: true,
      },
      enterprise: {
        title: "Enterprise",
        price: "Custom",
        period: "",
        features: ["Everything in Pro", "Dedicated Support", "SLA Guarantee", "Bulk Management", "API Access"],
        cta: "Contact Us",
      },
    },
    auth: {
      login_title: "Welcome Back",
      login_subtitle: "Sign in to manage your DNS records",
      register_title: "Create Account",
      register_subtitle: "Start managing your free DNS records today",
      email: "Email Address",
      password: "Password",
      confirm_password: "Confirm Password",
      login_btn: "Sign In",
      register_btn: "Create Account",
      no_account: "Don't have an account?",
      has_account: "Already have an account?",
      register_link: "Sign up",
      login_link: "Sign in",
      verify_title: "Verify Your Email",
      verify_subtitle: "We sent a 6-digit code to",
      verify_btn: "Verify",
      verify_enter_code: "Please enter the 6-digit code",
      verify_success: "Email verified successfully!",
      verify_code_sent: "Verification code sent to your email",
      verify_resent: "New code sent!",
      verify_no_code: "Didn't receive the code?",
      verify_resend: "Resend Code",
      google_login: "Continue with Google",
      google_signing_in: "Connecting…",
      or_separator: "OR",
      forgot_password: "Forgot password?",
      forgot_title: "Reset Your Password",
      forgot_subtitle: "Enter your email and we'll send you a reset link",
      forgot_send: "Send Reset Link",
      forgot_sent: "Reset link sent! Check your inbox.",
      forgot_no_account: "No account found with this email",
      forgot_rate_limit: "Too many requests. Please wait 15 minutes and try again.",
      registration_disabled_title: "Registration Closed",
      registration_disabled_msg: "Form-based registration is currently disabled. Please try again later or use Google login if available.",
      reset_title: "Set New Password",
      reset_subtitle: "Choose a strong password for your account",
      reset_new_password: "New Password",
      reset_confirm: "Confirm New Password",
      reset_submit: "Reset Password",
      reset_success: "Password reset! Please log in.",
      reset_invalid: "Invalid or expired reset link",
      reset_no_token: "No reset token provided",
      back_to_login: "Back to login",
    },
    dashboard: {
      title: "DNS Dashboard",
      add_record: "Add Record",
      records: "DNS Records",
      no_records: "No DNS records yet. Create your first one!",
      subdomain: "Subdomain",
      type: "Type",
      content: "Content / Value",
      ttl: "TTL",
      proxied: "Proxied",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      save: "Save Changes",
      cancel: "Cancel",
      create: "Create Record",
      record_type: "Record Type",
      ip_address: "IP Address",
      target: "Target Domain",
      plan: "Plan",
      records_used: "Records Used",
      upgrade: "Upgrade Plan",
      delete_confirm: "Are you sure you want to delete this record? This action cannot be undone.",
      delete_title: "Delete Record",
      edit_title: "Edit Record",
      create_title: "Create New Record",
      subdomain_placeholder: "e.g. blog, app, my-site",
      select_domain: "Select Domain",
      content_placeholder_a: "e.g. 192.168.1.1",
      content_placeholder_aaaa: "e.g. 2001:db8::1",
      content_placeholder_cname: "e.g. example.com",
      content_placeholder_ns: "e.g. ns1.example.com",
      stats: {
        total_records: "Total Records",
        record_limit: "Record Limit",
        plan_type: "Current Plan",
        unlimited: "Unlimited",
      },
    },
    footer: {
      description: "Free Dynamic DNS service powered by Cloudflare infrastructure.",
      contact: "Contact",
      telegram: "Telegram",
      rights: "All rights reserved.",
      domain: "dnslab.biz",
    },
    admin: {
      title: "Admin Panel",
      users: "Users",
      total_users: "Total Users",
      total_records: "Total Records",
      free_users: "Free Users",
      premium_users: "Premium Users",
      email: "Email",
      plan: "Plan",
      role: "Role",
      records: "Records",
      joined: "Joined",
      actions: "Actions",
      change_plan: "Change Plan",
      delete_user: "Delete User",
      delete_confirm: "Are you sure you want to delete this user and all their DNS records?",
      set_free: "Set Free",
      set_premium: "Set Premium",
      setup_admin: "Setup Admin",
      setup_desc: "Promote user to admin role",
      no_users: "No users found",
      gmail_only: "Only Gmail addresses (@gmail.com) are allowed",
      view_records: "User DNS Records",
      no_records: "This user has no DNS records",
      delete_record: "Delete Record",
      delete_record_confirm: "Are you sure you want to delete this DNS record from Cloudflare?",
      domains: "Domains",
      domain_name: "Domain Name",
      zone_id: "Zone ID",
      add_domain: "Add Domain",
      domain_name_placeholder: "e.g. example.com",
      zone_id_placeholder: "Cloudflare Zone ID",
      domain_active: "Active",
      domain_inactive: "Inactive",
      delete_domain: "Delete Domain",
      delete_domain_confirm: "Are you sure you want to delete this domain? It must not have any active records.",
      no_domains: "No domains added yet",
      total_domains: "Total Domains",
      active_domains: "Active Domains",
      oauth_tab: "OAuth",
      oauth_title: "Google OAuth",
      oauth_desc: "Configure Google sign-in for login & registration",
      oauth_enabled: "Google login enabled",
      oauth_client_id: "Client ID",
      oauth_client_secret: "Client Secret",
      oauth_client_id_placeholder: "xxxxx.apps.googleusercontent.com",
      oauth_client_secret_placeholder: "GOCSPX-…",
      oauth_save: "Save Settings",
      oauth_saved: "OAuth settings saved",
      oauth_hint: "Get these from Google Cloud Console → Credentials",
      settings_tab: "Settings",
      settings_title: "System Settings",
      settings_desc: "Control system-wide flags",
      registration_toggle: "Form registration enabled",
      registration_toggle_desc: "When off, users can no longer create accounts via the email/password form. Google login (if enabled) and existing accounts continue to work.",
      settings_save: "Save Settings",
      settings_saved: "Settings saved",
    },
  },
  fa: {
    nav: {
      home: "خانه",
      pricing: "قیمت\u200Cها",
      dashboard: "داشبورد",
      admin: "پنل مدیریت",
      login: "ورود",
      register: "ثبت\u200Cنام",
      logout: "خروج",
    },
    hero: {
      title: "DNS داینامیک رایگان",
      subtitle: "ساب\u200Cدامنه رایگان روی dnslab.biz بگیرید. رکوردهای A، AAAA و CNAME را با داشبورد قدرتمند ما مدیریت کنید.",
      cta: "شروع رایگان",
      learn: "مشاهده قیمت\u200Cها",
    },
    features: {
      title: "چرا DNSLAB.BIZ؟",
      subtitle: "همه چیزی که برای مدیریت قابل اعتماد DNS نیاز دارید",
      speed: { title: "سرعت بالا", desc: "انتشار DNS در چند ثانیه با شبکه جهانی Cloudflare." },
      security: { title: "امنیت پیش\u200Cفرض", desc: "محافظت شده توسط زیرساخت امنیتی سازمانی Cloudflare." },
      free: { title: "رایگان برای همیشه", desc: "تا ۲ رکورد DNS کاملا رایگان. بدون نیاز به کارت اعتباری." },
      easy: { title: "داشبورد آسان", desc: "داشبورد ساده و کاربردی برای ایجاد و مدیریت رکوردهای DNS." },
      types: { title: "انواع رکورد", desc: "پشتیبانی کامل از رکوردهای A، AAAA، CNAME و NS." },
      api: { title: "رکوردهای واقعی DNS", desc: "رکوردها روی زیرساخت Cloudflare ساخته می\u200Cشوند. DNS واقعی، نه پروکسی." },
    },
    pricing: {
      title: "قیمت\u200Cگذاری ساده",
      subtitle: "رایگان شروع کنید، وقتی نیاز داشتید ارتقا دهید",
      free: {
        title: "رایگان",
        price: "۰ تومان",
        period: "برای همیشه",
        features: ["۲ رکورد DNS", "انواع A، AAAA، CNAME، NS", "DNS کلادفلر", "دسترسی به داشبورد"],
        cta: "شروع کنید",
      },
      pro: {
        title: "حرفه\u200Cای",
        price: "تماس بگیرید",
        period: "",
        features: ["رکورد نامحدود", "انواع A، AAAA، CNAME، NS", "DNS کلادفلر", "پشتیبانی اولویت\u200Cدار", "TTL سفارشی"],
        cta: "تماس در تلگرام",
        popular: true,
      },
      enterprise: {
        title: "سازمانی",
        price: "سفارشی",
        period: "",
        features: ["همه امکانات حرفه\u200Cای", "پشتیبانی اختصاصی", "تضمین SLA", "مدیریت انبوه", "دسترسی API"],
        cta: "تماس بگیرید",
      },
    },
    auth: {
      login_title: "خوش آمدید",
      login_subtitle: "برای مدیریت رکوردهای DNS خود وارد شوید",
      register_title: "ایجاد حساب کاربری",
      register_subtitle: "همین امروز مدیریت رکوردهای DNS رایگان خود را شروع کنید",
      email: "آدرس ایمیل",
      password: "رمز عبور",
      confirm_password: "تکرار رمز عبور",
      login_btn: "ورود",
      register_btn: "ثبت\u200Cنام",
      no_account: "حساب کاربری ندارید؟",
      has_account: "حساب کاربری دارید؟",
      register_link: "ثبت\u200Cنام کنید",
      login_link: "وارد شوید",
      verify_title: "تایید ایمیل",
      verify_subtitle: "یک کد ۶ رقمی ارسال شد به",
      verify_btn: "تایید",
      verify_enter_code: "لطفاً کد ۶ رقمی را وارد کنید",
      verify_success: "ایمیل با موفقیت تایید شد!",
      verify_code_sent: "کد تایید به ایمیل شما ارسال شد",
      verify_resent: "کد جدید ارسال شد!",
      verify_no_code: "کد را دریافت نکردید؟",
      verify_resend: "ارسال مجدد کد",
      google_login: "ورود با گوگل",
      google_signing_in: "در حال اتصال…",
      or_separator: "یا",
      forgot_password: "رمز عبور را فراموش کرده\u200Cاید؟",
      forgot_title: "بازیابی رمز عبور",
      forgot_subtitle: "ایمیل خود را وارد کنید تا لینک بازیابی برایتان ارسال شود",
      forgot_send: "ارسال لینک بازیابی",
      forgot_sent: "لینک بازیابی ارسال شد! ایمیل خود را بررسی کنید.",
      forgot_no_account: "حسابی با این ایمیل پیدا نشد",
      forgot_rate_limit: "درخواست\u200Cهای بیش از حد. لطفاً ۱۵ دقیقه صبر کنید و دوباره تلاش کنید.",
      registration_disabled_title: "ثبت\u200Cنام بسته است",
      registration_disabled_msg: "ثبت\u200Cنام از طریق فرم در حال حاضر غیرفعال است. لطفاً بعداً تلاش کنید یا اگر در دسترس بود از ورود با گوگل استفاده کنید.",
      reset_title: "تنظیم رمز جدید",
      reset_subtitle: "یک رمز قوی برای حساب خود انتخاب کنید",
      reset_new_password: "رمز عبور جدید",
      reset_confirm: "تکرار رمز جدید",
      reset_submit: "ذخیره رمز جدید",
      reset_success: "رمز عبور بازیابی شد! اکنون وارد شوید.",
      reset_invalid: "لینک بازیابی نامعتبر یا منقضی شده است",
      reset_no_token: "توکن بازیابی موجود نیست",
      back_to_login: "بازگشت به ورود",
    },
    dashboard: {
      title: "داشبورد DNS",
      add_record: "افزودن رکورد",
      records: "رکوردهای DNS",
      no_records: "هنوز رکورد DNS ندارید. اولین رکورد خود را بسازید!",
      subdomain: "ساب\u200Cدامنه",
      type: "نوع",
      content: "محتوا / مقدار",
      ttl: "TTL",
      proxied: "پراکسی",
      actions: "عملیات",
      edit: "ویرایش",
      delete: "حذف",
      save: "ذخیره تغییرات",
      cancel: "لغو",
      create: "ایجاد رکورد",
      record_type: "نوع رکورد",
      ip_address: "آدرس IP",
      target: "دامنه مقصد",
      plan: "پلن",
      records_used: "رکوردهای استفاده شده",
      upgrade: "ارتقای پلن",
      delete_confirm: "آیا مطمئنید که می\u200Cخواهید این رکورد را حذف کنید؟ این عمل قابل بازگشت نیست.",
      delete_title: "حذف رکورد",
      edit_title: "ویرایش رکورد",
      create_title: "ایجاد رکورد جدید",
      subdomain_placeholder: "مثلا blog، app، my-site",
      select_domain: "انتخاب دامنه",
      content_placeholder_a: "مثلا 192.168.1.1",
      content_placeholder_aaaa: "مثلا 2001:db8::1",
      content_placeholder_cname: "مثلا example.com",
      content_placeholder_ns: "مثلا ns1.example.com",
      stats: {
        total_records: "تعداد رکوردها",
        record_limit: "سقف رکورد",
        plan_type: "پلن فعلی",
        unlimited: "نامحدود",
      },
    },
    footer: {
      description: "سرویس DNS داینامیک رایگان با قدرت زیرساخت Cloudflare.",
      contact: "تماس با ما",
      telegram: "تلگرام",
      rights: "تمام حقوق محفوظ است.",
      domain: "dnslab.biz",
    },
    admin: {
      title: "پنل مدیریت",
      users: "کاربران",
      total_users: "کل کاربران",
      total_records: "کل رکوردها",
      free_users: "کاربران رایگان",
      premium_users: "کاربران حرفه\u200Cای",
      email: "ایمیل",
      plan: "پلن",
      role: "نقش",
      records: "رکوردها",
      joined: "تاریخ عضویت",
      actions: "عملیات",
      change_plan: "تغییر پلن",
      delete_user: "حذف کاربر",
      delete_confirm: "آیا مطمئنید که می\u200Cخواهید این کاربر و تمام رکوردهای DNS آن را حذف کنید؟",
      set_free: "رایگان",
      set_premium: "حرفه\u200Cای",
      setup_admin: "تنظیم ادمین",
      setup_desc: "ارتقای کاربر به نقش ادمین",
      no_users: "کاربری یافت نشد",
      gmail_only: "فقط آدرس\u200Cهای جیمیل (@gmail.com) مجاز هستند",
      view_records: "رکوردهای DNS کاربر",
      no_records: "این کاربر هیچ رکورد DNS ندارد",
      delete_record: "حذف رکورد",
      delete_record_confirm: "آیا مطمئنید که می\u200Cخواهید این رکورد DNS را از Cloudflare حذف کنید؟",
      domains: "دامنه\u200Cها",
      domain_name: "نام دامنه",
      zone_id: "شناسه Zone",
      add_domain: "افزودن دامنه",
      domain_name_placeholder: "مثلا example.com",
      zone_id_placeholder: "شناسه Zone کلادفلر",
      domain_active: "فعال",
      domain_inactive: "غیرفعال",
      delete_domain: "حذف دامنه",
      delete_domain_confirm: "آیا مطمئنید که می\u200Cخواهید این دامنه را حذف کنید؟ نباید رکورد فعالی داشته باشد.",
      no_domains: "هنوز دامنه\u200Cای اضافه نشده",
      total_domains: "کل دامنه\u200Cها",
      active_domains: "دامنه\u200Cهای فعال",
      oauth_tab: "OAuth",
      oauth_title: "گوگل OAuth",
      oauth_desc: "تنظیم ورود با گوگل برای صفحات لاگین و ثبت\u200Cنام",
      oauth_enabled: "ورود با گوگل فعال",
      oauth_client_id: "Client ID",
      oauth_client_secret: "Client Secret",
      oauth_client_id_placeholder: "xxxxx.apps.googleusercontent.com",
      oauth_client_secret_placeholder: "GOCSPX-…",
      oauth_save: "ذخیره تنظیمات",
      oauth_saved: "تنظیمات ذخیره شد",
      oauth_hint: "از Google Cloud Console → Credentials دریافت کنید",
      settings_tab: "تنظیمات",
      settings_title: "تنظیمات سیستم",
      settings_desc: "کنترل پرچم\u200Cهای سراسری سیستم",
      registration_toggle: "ثبت\u200Cنام از طریق فرم فعال",
      registration_toggle_desc: "وقتی خاموش است، کاربران دیگر نمی\u200Cتوانند با فرم ایمیل/رمز حساب بسازند. ورود با گوگل (در صورت فعال بودن) و حساب\u200Cهای موجود همچنان کار می\u200Cکنند.",
      settings_save: "ذخیره تنظیمات",
      settings_saved: "تنظیمات ذخیره شد",
    },
  },
};
